import makeStyles from '@mui/styles/makeStyles'

const useMonthlyGenerationDownloadStyles = makeStyles({
  root: {},
})

export default useMonthlyGenerationDownloadStyles
